require('../../modules/es7.string.trim-right');
module.exports = require('../../modules/_core').String.trimRight;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/string/trim-end.js
// module id = 9nAu
// module chunks = 0